<script setup lang="ts">
import CheckpointSummary from "~/dto/checkpoint/Summary";

const { t } = useI18n();

defineProps({
  summary: {
    type: CheckpointSummary,
    required: true
  }
});
</script>

<template>
  <div class="card bg-body-secondary">
    <NuxtLink :to="{ name: 'checkpoint-code', params: { code: summary.code } }">
      <img
          class="card-img-top"
          :src="'/images/checkpoints/' + summary.code + '.jpg'"
          :alt="summary.name"
      >
    </NuxtLink>
    <div class="card-body position-relative">
      <div class="position-absolute top-0 end-0 pt-2 pe-3">
        <i class="cil-arrow-thick-to-right icon icon-md align-top mt-2" />
        <i
            class="icon icon-xxl"
            :class="'cif-' + summary.countryCode"
        />
      </div>
      <h5 class="card-title">
        <NuxtLink
            class="h5 link-underline link-underline-opacity-0"
            :to="{ name: 'checkpoint-code', params: { code: summary.code } }"
        >
          {{ summary.name }}
        </NuxtLink>
      </h5>
      <div
          v-if="summary.carsQueues"
          v-tooltip="t('home.tooltip_queues_total')"
          class="d-inline-block me-1"
      >
        <i class="cil-car icon icon-lg" />
        <span class="h5 ms-1">{{ summary.carsQueues.total }}</span>
      </div>
      <div
          v-if="summary.carsQueues?.live.duration"
          v-tooltip="t('home.tooltip_queue_duration')"
          class="d-inline-block float-end"
      >
        <i class="cil-hourglass icon icon-lg" />
        <FormattedQueueDuration
            class="ms-1"
            :duration="summary.carsQueues.live.duration"
        />
      </div>
    </div>
  </div>
</template>
